import { useState } from 'react'
import PropTypes from 'prop-types'

import AuthLayout from '../AuthLayout'

import CommunityCode from './CommunityCode'
import PasswordSetup from './PasswordSetup'
import UserData from './UserData'

const SelfSignup = ({ location }) => {
  const [step, setStep] = useState('community-code')
  const [formState, setFormState] = useState({
    communityCode: '',
    email: location?.state?.email ?? '',
    password: '',
    password2: '',
  })

  const renderStep = () => {
    switch (step) {
      case 'community-code':
        return <CommunityCode formState={formState} setFormState={setFormState} setStep={setStep} />
      case 'password':
        return <PasswordSetup formState={formState} setFormState={setFormState} setStep={setStep} />
      case 'user-data':
        return <UserData formState={formState} setFormState={setFormState} setStep={setStep} />
    }
  }

  return <AuthLayout>{renderStep()}</AuthLayout>
}

SelfSignup.propTypes = {
  location: PropTypes.object,
}

export default SelfSignup
